import { useRouter } from "next/router"
import { useState } from "react"
import { useForm } from "react-hook-form"
import fetchPathData from "@/lib/api/fetchPathData"
import { useAppContext } from "@/lib/contexts/appContext"
import { useMember } from "@/lib/hooks/useMember"
import cx from "classnames"
import Block from "@/components/wrappers/block"
import Button from "@/common/button/button"
import styles from "@/common/form/input.module.css"

export default function PasswordForm({ block }) {
  const [error, setError] = useState()
  const { setPathData } = useAppContext()
  const { hasMounted, token } = useMember()
  const methods = useForm({
    mode: "onTouched"
  })
  const { isSubmitting } = methods.formState

  const router = useRouter()

  const onSubmit = async ({ password }) => {
    error && setError(false)

    const pathData = await fetchPathData(
      { path: router.asPath, password },
      token
    )

    if (pathData.status === 200) {
      setPathData(pathData)
    } else {
      setError(true)
    }
  }

  if (!hasMounted) {
    return null
  }

  return (
    <Block block={block} width="column">
      <form
        className="max-w-md mx-auto"
        onSubmit={methods.handleSubmit(onSubmit)}>
        <input
          type="password"
          className={cx(styles.input, "mb-4")}
          {...methods.register("password", { required: true })}
          placeholder="Ange lösenord"
        />
        <Button
          ariaLabel={isSubmitting ? "Hämtar..." : "Skicka"}
          size="small"
          theme="lime"
          type="submit"
          className="w-full">
          {isSubmitting ? "Hämtar..." : "Skicka"}
        </Button>
        {error && (
          <p className="mt-4 text-sm text-center text-red-100">
            Fel lösenord, vänligen försök igen.
          </p>
        )}
      </form>
    </Block>
  )
}
